import React from "react";
import {
  FaChartBar,
  FaExchangeAlt,
  FaPalette,
  FaShieldAlt,
  FaSyncAlt,
} from "react-icons/fa";

function CustomizableUIUX() {
  return (
    <>
      <div
        className="process-style-three-area default-padding bg-dark text-light bg-cover"
        style={{
          backgroundImage:
            "url(https://validthemes.net/site-template/robok/assets/img/shape/banner-22.jpg)",
        }}
      >
        <div className="shape">
          <img
            src="https://validthemes.net/site-template/robok/assets/img/illustration/16.png"
            alt="Image Not Found"
          />
        </div>
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="site-heading">
                <h4 className="sub-title">How it works</h4>
                <h2 className="title split-text-right split-text-in-right">
                  Stunning Features & Functionalities offered by Xeer
                  Technology’s DEX Aggregator Development Service
                </h2>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-11 offset-lg-2">
              <div className="process-style-three-items">
                <div className="process-style-three-item fade-up-anim">
                  <div className="icon">
                    <FaPalette size={40} />
                  </div>
                  <h4>Customizable UI/UX</h4>
                  <p>
                    Tailor-made interfaces designed for a smooth trading
                    experience, customizable to suit your brand’s identity and
                    enhance user engagement.
                  </p>
                </div>

                <div className="process-style-three-item fade-up-anim">
                  <div className="icon">
                    <FaSyncAlt size={40} />
                  </div>
                  <h4>Real-Time Data Feeds</h4>
                  <p>
                    Integrated price feeds and liquidity updates ensure that
                    users receive accurate, up-to-the-moment data on all trades
                    and liquidity sources.
                  </p>
                </div>

                <div className="process-style-three-item fade-up-anim">
                  <div className="icon">
                    <FaShieldAlt size={40} />
                  </div>
                  <h4>Secure Smart Contract Architecture</h4>
                  <p>
                    Our DEX aggregators are backed by robust, audited smart
                    contracts, ensuring secure transactions and safeguarding
                    user funds throughout the trading process.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container pt-5">
          <div className="row justify-content-center">
            <div className="col-lg-10 offset-lg-2">
              <div className="process-style-three-items">
                <div className="process-style-three-item fade-up-anim">
                  <div className="icon">
                    <FaExchangeAlt size={40} />
                  </div>
                  <h4>Multi-Chain Asset Swapping</h4>
                  <p>
                    Enable users to seamlessly swap assets across chains with
                    our multi-chain integration, enhancing flexibility and
                    trading opportunities within your aggregator.
                  </p>
                </div>
                <div className="process-style-three-item fade-up-anim">
                  <div className="icon">
                    <FaChartBar size={40} />
                  </div>
                  <h4>Analytics and Performance Tracking</h4>
                  <p>
                    Detailed analytics features allow users to monitor
                    transaction history, trading volume, and slippage, providing
                    insight into trading performance and trends.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default CustomizableUIUX;
